import React, { useEffect } from "react";
// Msal imports
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
// Sample app imports
import { DashboardComponent } from "../components/DashboardComponent";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";

export function Dashboard() {
  const authRequest = {
    ...loginRequest,
  };
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const getUserEMail = JSON.parse(localStorage.getItem("USER_EMAIL"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_EMPCODE"));
  const CustomerContent = () => {
    return (
      <DashboardComponent
        USER_EMAIL={getUserEMail}
        EMP_CODE={getEmpCode}
        USER_ROLE={getUserRole}
        CRM_ID={getUserID}
      />
    );
  };
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <DashboardComponent />
      {/* {getUserRole === "1" && <CustomerContentHead />}
      {getUserRole === "3" && <CustomerContentHead />}
      {getUserRole === "7" && <CustomerContentHead />}
      {getUserRole === "14" && <CustomerContentHead />} */}
    </MsalAuthenticationTemplate>
  );
}
